import { makeStyles } from "@material-ui/core";

const underlineColor = "#7c7c7c";

export default makeStyles(theme => ({
    "@keyframes rotate": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(180deg)"
        }
    },
    working: {
        animation: `$rotate 1s ${theme.transitions.easing.easeInOut} infinite`
    },
    buttonRoot: {
        minWidth: "auto"
    },
    outlinedSmall: {
        padding: "1px 9px"
    },
    qtyField: {
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: 5,
            paddingBottom: 5
        }
    },
    input: {
        fontSize: "1rem!important",
        textTransform: "uppercase"
    },
    textField: {
        // input label when focused
        "& label.Mui-focused": {
            color: underlineColor
        },
        // focused color for input with variant='standard'
        "& .MuiInput-underline:after": {
            borderBottomColor: underlineColor
        },
        // focused color for input with variant='filled'
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: underlineColor
        },
        // focused color for input with variant='outlined'
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: underlineColor
            }
        },
        "& .MuiInput-root": {
            paddingBottom: "0px!important"
        }
    }
}));
